import { Directive, Host, HostListener, Self } from '@angular/core';
import { Calendar } from 'primeng/calendar';

@Directive({
  selector: '[appUseUtc]'
})
export class UseUtcDirective {

  constructor(@Host() @Self() private calendar: Calendar) { }

  @HostListener('onSelect', ['$event']) onSelect() {
    this.toUtc();
  }

  @HostListener('onInput', ['$event']) onInput() {
    this.toUtc();
  }

  private toUtc(){
    //Get UTC Time
    let cal = new Date(Date.UTC(this.calendar.value.getFullYear()
    , this.calendar.value.getMonth()
    , this.calendar.value.getDate()
    ,0, 0, 0))
    //Negated timezone offset
    let offset = new Date().getTimezoneOffset() * 60000
    //Convert to Localtime with offset
    cal = new Date(cal.getTime()+ (-1*offset))
    this.calendar.value = cal;

    this.calendar.updateModel(this.calendar.value);
    console.log(this.calendar)
  }
}